import { RequestBaseSet } from "@myapp/modules/fwcore/models/messages/request-base";
import { ResponseBaseSet } from "@myapp/modules/fwcore/models/messages/response-base";
import { UserImport } from "../user-import";

export class RequestUserImportSet extends RequestBaseSet<UserImport>
{
  public companyId?: string | null = null;
  public licenseId?: string | null = null;
  public isActive?: boolean | null = null;
}

export class ResponseUserImportSet extends ResponseBaseSet<UserImport>{

}
